import React from 'react';
import Styles from './PartiuGpRegulamento.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

const REGULAMENTO_PDF = 'assets/partiu-gp-da-inglaterra/regulamento-f1-2026.pdf';

function PartiuGpRegulamento() {
  return (
    <section id="partiu-gp-regulamento">
      <ContainerHome24>
        <p className="eyebrow">Regulamento</p>
        <h2 className="titulo">Consulte o regulamento completo</h2>
        <p className="texto">
          Entenda em detalhes os critérios de participação, elegibilidade, sorteio e premiação.
        </p>
        <div className="actions">
          <a href={REGULAMENTO_PDF} target="_blank" rel="noopener" className="btn-outline">
            Consultar
          </a>
          <a
            href={REGULAMENTO_PDF}
            download="regulamento-partiu-gp-da-inglaterra.pdf"
            className="link"
          >
            Baixar Regulamento
          </a>
        </div>
        <p className="disclaimer">
          Contratação de financiamento sujeita à análise de crédito.
          <br />
          <br />
          Promoção Partiu GP da Inglaterra com Santander: Certificado de Autorização SPA/ME Nº
          04.052484/2026.
          <br />
          <br />
          Para a taxa de juros de 1,29% a.m., considerando uma simulação realizada em 01/09/2026,
          com base em um financiamento de veículo no valor de R$100.000,00, com entrada de 80% (R$
          80.000,00) e financiamento de 20% (R$ 20.000,00), em 24 parcelas fixas de R$ 1,017.11, sem
          inclusão de tarifas, registro no DETRAN e IOF, o Custo Efetivo Total (CET) é de 1.66%.
          Condição válida para correntistas Santander, para veículos fabricados em 2025 ou mais
          novos.
        </p>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpRegulamento;
